import BiRewardsModal from 'components/GlobalModals/BiRewardsModal/BiRewardsModal';
import { withBiRewardsModalProps } from 'viewModel/globalModals/BiRewardsModal/withBiRewardsModalProps';
const ConnectedBiRewardsModalProps = withBiRewardsModalProps(BiRewardsModal);

export default ConnectedBiRewardsModalProps;
